export default __webpack_public_path__ + "static/media/card-profile.456e3149.jpg";